<template>
  <div class="app">
    <template v-if="isAdmin">
      <div class="layout" :class="{ open: openSidebar }">
        <div class="navbar navbar-expand-lg">
          <div class="container-fluid">
            <a href="/seguro-de-vida/rumbo" class="navbar-brand">
              <img
                :src="require('@/assets/images/app/rumbo-white.svg')"
                loading="lazy"
                alt=""
              />
            </a>
            <button
              class="navbar-toggler mr-auto"
              type="button"
              @click="toggleSidebar()"
            >
              <i class="fas fa-bars"></i>
            </button>
            <ul class="navbar-nav ms-auto">
              <li class="nav-item user-name" v-if="user">
                {{ user.firstName }} {{ user.lastName }}
              </li>
              <li class="nav-item user-actions"></li>
            </ul>
            <b-dropdown class="user-menu">
              <template #button-content>
                <i class="fas fa-user"></i>
              </template>
              <li>
                <b-dropdown-item @click="logout()">
                  <i class="fas fa-sign-out"></i>Cerrar
                  Sesi&oacute;n</b-dropdown-item
                >
              </li>
            </b-dropdown>
          </div>
        </div>
        <div class="sidebar">
          <div class="sidebar-info">
            <template v-if="!isAdminPolices">
              <h4>Acerca de Rumbo</h4>
              <div class="sidebar-info__item">
                <img :src="require('@/assets/images/app/group.svg')" alt="" />
                <span
                  >Actualiza tus beneficiarios llamando al (01) 500-0000
</span
                >
              </div>
              <div class="sidebar-info__item">
                <img :src="require('@/assets/images/app/shield.svg')" alt="" />
                <span
                  >Tu ahorro incluye un seguro de vida por S/ 25,000 para
                  proteger a los que más amas</span
                >
              </div>
            </template>
            <template v-if="isAdminPolices">
              <div class="sidebar-info__navigate">
                <router-link to="./policies">P&oacute;lizas</router-link>
                <template v-if="isSuperAdmin">
                  <router-link to="./operations">Operaciones</router-link>
                  <router-link to="./payments-upload">Pagos</router-link>
                  <router-link to="./promos-upload">Promociones</router-link>
                  <router-link to="./data-consistency">Consistencia de datos</router-link>
                  <router-link to="./persistence">Persistecia de clientes</router-link>
                </template>
              </div>
            </template>
          </div>
        </div>
        <div class="content">
          <router-view />
        </div>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BCollapse,
  BCard,
  VBToggle,
  DropdownPlugin,
  BDropdown,
} from "bootstrap-vue";

// import "@fortawesome/fontawesome-free/css/all.min.css";

export default defineComponent({
  name: "App",
  components: {
    BButton,
    BCardText,
    BCollapse,
    BCard,
    VBToggle,
    BModal,
    "b-dropdown": BDropdown,
  },
  setTemplate() {
    let location: any = window.location;
    let path: string = location.pathname;

    if (path.indexOf("client-zone") > -1 || path.indexOf("admin") > -1) {
      this.isAdmin = true;
    }
  },
  created() {
    this.init();
  },
  data() {
    return {
      user: null,
      isAdmin: false,
      openSidebar: false,
      isAdminPolices: false,
      isSuperAdmin: false,
    };
  },
  methods: {
    init() {
      this.getUser();
      this.setTemplate();
    },
    getUser() {
      let user: any = JSON.parse(localStorage.getItem("__user__"));
      this.user = user;

      if(user && user.roles && user.roles.length > 0 && user.roles[0] === 'Admin') {
        this.isSuperAdmin = true;
      }
    },
    setTemplate() {
      let location: any = window.location;
      let path: string = location.pathname;

      if (path.indexOf("client-zone") > -1) {
        this.isAdmin = true;
      }

      if (path.indexOf("admin") > -1) {
        this.isAdmin = true;
        this.isAdminPolices = true;
      }
    },
    logout() {
      window.localStorage.clear();
      window.location.href = "/seguro-de-vida/rumbo/";
    },
    toggleSidebar() {
      this.openSidebar = !this.openSidebar;
    },
  },
});
</script>

<style lang="scss">
@import "./styles/abstracts/variables";

$sidebarWidth: 250px;

.layout {
  background-color: #f4f6fc;

  &.open {
    .sidebar {
      left: 0;
      z-index: 100;
    }
  }

  .navbar {
    background-color: $mainColor;
    position: relative;
    z-index: 100;
    width: 100%;

    .navbar-brand {
      img {
        width: 120px;
      }
    }

    &-toggler {
      margin-right: auto !important;
      border: none !important;

      &:focus {
        box-shadow: none !important;
      }

      i {
        color: #fff;
        font-size: 20px;
      }
    }
  }

  .user-name {
    color: #fff;
    font-weight: 500;
  }

  .user-menu {
    margin-left: 12px;

    .btn {
      background-color: transparent !important;
      border-color: #fff;
      border-width: 2px;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      &:after {
        content: none;
      }
    }

    .dropdown-menu {
      right: 0 !important;
      left: unset !important;
      transform: none !important;
      top: 100% !important;

      li {
        padding-left: 10px;
        cursor: pointer;

        i {
          margin-right: 7px;
        }
      }
    }
  }

  .sidebar {
    position: fixed;
    width: $sidebarWidth;
    background-color: #fff;
    height: calc(100vh - 58px);
    top: 58px;
    left: 0;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
    transition: 300ms;

    .sidebar-info {
      padding: 20px;

      h4 {
        color: $mainColor;
        font-weight: 500;
        font-size: 18px;
      }

      &__item {
        display: flex;
        font-size: 13px;
        align-items: flex-start;
        color: $mainColor;
        margin-bottom: 18px;
        font-weight: 500;
        line-height: 16px;

        img {
          width: 35px;
          height: 45px;
          margin-right: 10px;
        }

        .d-block {
          text-align: center;
          font-weight: 500;
          color: $mainColor;
        }

        a {
          color: #0855c4;
          text-decoration: underline;
        }
      }

      &__navigate {
        a {
          font-weight: 500;
          font-size: 14px;
          color: $primaryBlue;
          display: block;
          text-decoration: none;
          transition: 0.3s;

          &:hover {
            padding-left: 8px;
          }
        }
      }
    }
  }
}

.content {
  margin-left: $sidebarWidth;
  //padding: 20px 35px;
  padding: 20px;
  height: calc(100vh - 58px);
  overflow-y: scroll;
  overflow-x: hidden;
}

@media (max-width: 479px) {
  .layout {
    .navbar {
      .navbar-nav {
        display: none;
      }
    }

    .sidebar {
      left: -1 * $sidebarWidth;
    }

    .content {
      margin-left: 0;
    }
  }
}
</style>
